import gql from 'graphql-tag';

export const ALL_PAYMENT_METHODS = gql`
  query currentUnitPaymentMethods {
    currentUnit {
      id
      paymentMethods {
        id
        name
      }
    }
  },
`;

